import { Spacer } from "shared/layout";
import styled from "styled-components";

export const StyledEventTravelLegsWrapper = styled(Spacer)`
  @media print {
    display: block;
    margin-top: 0 !important;
  }
`;
